import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';
import {
  dailyReportUpdateRemark,
  attemptTranslateText
} from './actions';

class Remark extends Component{
  isContainerActive = () => {
    return this.props.remark.length
  };
  componentDidUpdate = (prevProps) => {
    if(!prevProps.englishRemark && this.props.englishRemark)
      this.props.scrollToBottom();
  };
  render()  {
    const { dispatch, remark, englishRemark } = this.props;
    return (
      <div style={styles.outerContainer}>
        <div className="row" style={[styles.container, this.isContainerActive() && styles.containerActive]}>
          <div className="col-xs-12" style={styles.heading}>
            Bemærkning
          <button className="btn btn-sm waves-btn" style={styles.translateButton} onClick={() => {dispatch(attemptTranslateText())}}>
            <i className="fa fa-globe fa-lg" style={styles.globe} aria-hidden="true"></i>
            Oversæt til engelsk
          </button>
          </div>
          {englishRemark ? <div style={[styles.colHeading, styles.firstColumn]} className="col-xs-12">Dansk</div> : null}
          <div style={styles.firstColumn} className="col-xs-12">
            <textarea
              style={styles.textarea}
              value={remark}
              placeholder="..."
              onChange={(evt) => dispatch(dailyReportUpdateRemark(evt.target.value))}/>
          </div>
          {englishRemark ?
            <div>
              <div style={[styles.colHeading, styles.firstColumn]} className="col-xs-12">English</div>
              <div style={styles.firstColumn} className="col-xs-12">
                <textarea
                  style={styles.textarea}
                  value={englishRemark}
                  onChange={(evt) => dispatch(dailyReportUpdateRemark(evt.target.value, 'englishRemark'))}/>
              </div>
            </div>
            :
            null
          }
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    margin: '0 0 12px 0',
    paddingRight: '12px'
  },
  container: {
    backgroundColor: greyScaleColors.greyLighter,
    padding: '2px 0 8px 6px',
    margin: '0',
    borderLeft: '2px solid ' + semanticColors.mainBackground
  },
  containerActive: {
    borderLeft: '2px solid ' + semanticColors.info
  },
  firstColumn: {
    paddingLeft: '0'
  },
  heading: {
    marginBottom: '20px',
    paddingLeft: '0',
    position: 'relative'
  },
  textarea: {
    '-webkit-appearance': 'none',  
    display: 'block',
    border: 'none',
    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
    width: '100%',
    height: '55px',
    resize: 'none',
    borderRadius: '2px',
    paddingLeft: '5px',
  },
  colHeading:{
    fontSize: '12px',
    paddingBottom: '4px',
    textAlign: 'left'
  },
  translateButton: {
    backgroundColor: greyScaleColors.greyLight,
    color: semanticColors.default,
    height: '27px',
    lineHeight: '4px',
    position: 'absolute',
    right: '12px',
    top: '4px'
  },
    globe: {
    fontSize: '21px',
    marginRight: '10px'
  }
}


const selectProps = state => {
  return {
    ...state.dailyReportRemarkReducer
  };
}

Remark.propTypes = {
    dispatch: PropTypes.func.isRequired,
    remark: PropTypes.string.isRequired,
    englishRemark: PropTypes.string,
    scrollToBottom: PropTypes.func.isRequired
  };

export default connect(selectProps)(Radium(Remark));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Remark/index.jsx